import i18nService from '@/services/i18n/i18n-service';

/** @return {number} */
export function toNumberCurrency(strCurrency) {
  if (strCurrency == null) return 0;

  const currencyRegex = /\d+(?:\.\d+)?|\.\d+/gi;
  const matches = strCurrency.match(currencyRegex);

  return matches?.length ? Number.parseFloat(matches[0]) : 0;
}

const DEFAULT_CURRENCY_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

/**
 * Formats a price value according to the specified locale and currency settings.
 *
 * @param {number|string} price - The price value to format.
 * @param {string} formattedLocale - The locale string (e.g., 'en_US') used for formatting.
 * @param {Object} currency - Currency configuration object.
 * @param {string} currency.currencyCode - The ISO currency code (e.g., 'USD').
 * @param {string|null} currency.currencyPlacement - Placement of the currency symbol ('before', 'after', or null).
 * @param {string} currency.currencySymbol - The symbol representing the currency (e.g., '$').
 * @param {Object} [currencyOptions] - Options for number formatting.
 * @param {number} [currencyOptions.minimumFractionDigits=2] - Minimum number of fraction digits.
 * @param {number} [currencyOptions.maximumFractionDigits=2] - Maximum number of fraction digits.
 * @returns {string} The formatted price string, or the original price if invalid.
 */
export function formatStorePrice(
  price,
  formattedLocale,
  currency,
  currencyOptions = DEFAULT_CURRENCY_OPTIONS,
) {
  if (Number.isNaN(Number(price))) return price;
  if (typeof formattedLocale !== 'string') return price;
  if (typeof currency !== 'object' || currency == null) return price;

  price = Number(price);
  const locale = formattedLocale.replace('_', '-');
  const localizedPrice = price.toLocaleString(locale, currencyOptions);

  return currency.currencyPlacement === 'after'
    ? localizedPrice + currency.currencySymbol
    : currency.currencySymbol + localizedPrice;
}

/** @return {string} */
export function localizeRenewalTerm(str) {
  if (typeof str !== 'string') return str;

  return str.replaceAll(/\/yr|\/mo/g, (match) => i18nService.t(match));
}
